// Stratos Theme Global Scripts
// Most functionality is scoped to sections (Header, Hero)
console.log('Stratos Theme Loaded');
